import React, { Component, Fragment } from "react";
import { func, bool } from "prop-types";
import LoadingOverlay from "../../Components/LoadingOverlay";
import SecretKeyForm from "../../Components/KeyholderSecretKeyForm";
import keyholderApi from "../../../api/keyholder";
import { createScryptHash } from "../crypto-utils";
import { handleError } from "@/util/errorHandler";

class FinalStep extends Component {
  static propTypes = {
    onSaveBackupFile: func.isRequired,
    isBackupSaved: bool.isRequired,
    isEachSecretKeySubmitted: bool.isRequired,
    isBankAccountCreated: bool.isRequired,
  };

  static defaultProps = {
    onSaveBackupFile: () => new Promise(),
    isBackupSaved: false,
  };

  state = {
    isLoading: false,
    aeskey: null,
  };

  onVadilateSecretKeyAndSaveBackup = async ({ secretKey }) => {
    this.setState({ isLoading: true });

    try {
      await keyholderApi
        .getSaltAndAeskey()
        .then(({ aeskey, salt }) => {
          this.setState({ aeskey });
          return createScryptHash(secretKey, salt);
        })
        .then(hash => keyholderApi.checkSecretKeyCorrectness(hash))
        .then(({ result }) => {
          result
            ? this.props.onSaveBackupFile(secretKey, this.state.aeskey)
            : handleError(
                new Error(
                  "The private key you entered is incorrect. Please be sure to provide the same secret key as before to save the correct backup.",
                ),
                { title: "Invalid secret key" },
              );

          return result;
        });
    } catch (err) {
      handleError(err, { title: "An error occured" });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { isLoading } = this.state;
    const {
      isBackupSaved,
      isEachSecretKeySubmitted,
      isBankAccountCreated,
    } = this.props;

    return (
      <Fragment>
        <LoadingOverlay loading={isLoading} />
        <div style={{ marginBottom: 10 }}>
          <h2>
            Completed!{" "}
            <i
              className="fa fa-check-circle"
              style={{ color: "#4dbd74", marginRight: 5 }}
              aria-hidden="true"
            />
            {getHeaderText(isEachSecretKeySubmitted, isBankAccountCreated)}
          </h2>
          {!isBackupSaved && (
            <span>Don't forget to save a backup of your secret key.</span>
          )}
        </div>
        {!isBackupSaved && (
          <SecretKeyForm
            isBackupForm
            onSubmit={this.onVadilateSecretKeyAndSaveBackup}
          />
        )}
      </Fragment>
    );
  }
}

function getHeaderText(isEachSecretKeySubmitted, isBankAccountCreated) {
  if (!isEachSecretKeySubmitted) return null;

  if (!isBankAccountCreated)
    return <span>The bank account is in the process of creating</span>;

  return <span>The bank account has been created</span>;
}

export default FinalStep;
